import {
  addDeviceSpecsToApm,
  submitPageImpression,
  trackDevicePixelRatio,
  trackDevicePreferences,
  trackDeviceTextSize,
} from "./async/tracking.js";

import { defineStore } from "../nexus/defines.js";
import { o_global } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import { hybridLegacy } from "./async/hybrid.js";
import { detectOrientation, Orientation } from "./async/orientation.js";
import * as screen from "./async/screen.js";
import { browser, getPointerType, getScreenSpecs, os, type } from "./index.js";
import { detectPointerType, initPointerTypeFlagging, isTouchable } from "./async/pointerType.js";

/**
 *
 */
assignNamespace(
  o_global,
  "device",
  { os, browser, type },
  {
    Orientation,
    orientation: detectOrientation(),
    isTouchable: isTouchable(),
    hybrid: hybridLegacy(),
    screen,
    breakpoint: o_global.breakpoint,
  },
);

otto.device.assignNamespace({
  pointerType: defineStore(),
  getPointerType,
  getScreenSpecs,
});

/*                          */
detectPointerType(otto.device);
initPointerTypeFlagging(otto.device);

/*                             */
trackDevicePreferences();
trackDeviceTextSize();
trackDevicePixelRatio();
submitPageImpression();
addDeviceSpecsToApm();
